import type { UseQueryHookResult } from '@reduxjs/toolkit/dist/query/react/buildHooks';
import { QueryEffect } from '@helpers/QueryEffect';
import { useAlert } from '@hooks/useAlert';

type SystemTableEffectsProps = {
    queries: UseQueryHookResult<any>[];
};

export const SystemTableEffects = ({ queries }: SystemTableEffectsProps) => {
    const { setAlert } = useAlert();

    return (
        <>
            {queries.map((queryState, index) => (
                <QueryEffect
                    key={`${index}-system-table-effect`}
                    queryState={queryState}
                    effects={{
                        isError: () => {
                            setAlert('Failed to fetch systems data', 'error');
                        },
                    }}
                />
            ))}
        </>
    );
};
